const BYTE_STEPS = ["bytes", "KB", "MB", "GB", "TB", "ZB", "YB"];

export default function Bytes({ bytes }: { bytes: number }) {
  const sign = bytes < 0 ? -1 : 1;
  let size = sign * bytes,
    suffix = 0;

  while (size > 1024) {
    size = size / 1024;
    suffix++;
  }

  size = sign * size;

  return (
    <span>
      {size === ~~size ? size : `~${size.toFixed(2)}`}&nbsp;{BYTE_STEPS[suffix]}
    </span>
  );
}
